export const userReferrerCookieName = 'user-referrer';
const referrer = document.referrer;
if (referrer) {
    const cookieRef = App.Util.getCookie(userReferrerCookieName);
    if (!cookieRef) {
        App.Util.setCookie(userReferrerCookieName, referrer);
    }
}
